import clsx from 'clsx';
import type { TextProps } from './Text.types';

const textStyles = [
  'typography-subtitle-1',
  'typography-subtitle-2',
  'typography-emphasis-1',
  'typography-emphasis-2',
  'typography-body-1',
  'typography-body-2',
  'typography-button',
  'typography-chip-style',
  'typography-caption-1'
];

const Text = ({ as, variant, children, color, className, ...props }: TextProps) => {
  const TextElement = as ?? 'p';
  const styles = clsx(
    variant ? textStyles.find((style) => style === `typography-${variant}`) : 'typography-body-1',
    color,
    className
  );

  return (
    <TextElement className={styles} {...props}>
      {children}
    </TextElement>
  );
};

export { Text };
